import axios from "axios"

export const getUser = async () => {
  try {
    const res = await axios.get(`/users/me`)
    return res.data
  } catch (err) {
    console.log("getUser err", err)
  }

  return null
}
